//Author: Elli Scharlin
//Copyright (c) 2022, Audigent
import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import RequestDealModal from './RequestDealModal';
const Container = styled.div`
    color: #b68f54;
    cursor: pointer;
    margin-left: 12px;
    white-space: nowrap;
    &:hover {
        color: #806040;
    }
    &:focus {
        color: #593f2d;
    }
`;

export default function DealButton({
    children,
    disable,
    width = 'fit',
    type = 'none',
    url = '',
    onClick = () => {},
    dealName,
}) {
    const [openModal, setOpenModal] = useState(false);
    const closeModal = () => {
        setOpenModal(false);
    };
    return (
        <React.Fragment>
            <Container
                disable={disable}
                width={width}
                onClick={() =>
                    type === 'request-deal'
                        ? setOpenModal(true)
                        : type === 'none'
                        ? onClick()
                        : {}
                }
            >
                {type === 'url' && <Link to={url}>{children}</Link>}
                {(type === 'request-deal' || type === 'none') && (
                    <React.Fragment>Request Deal</React.Fragment>
                )}
                {type === 'download' && (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                )}
            </Container>
            <RequestDealModal
                isOpen={openModal}
                closeModal={() => closeModal()}
                dealName={dealName}
            />
        </React.Fragment>
    );
}
